// Packages
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

// Components
import Menu from './components/Menu';
import Cursor from './components/Cursor';
import Modal from './components/Modal';

// Managers
import AjaxForms from './managers/AjaxForms';
import VimeoVideos from './managers/VimeoVideos';
import Galleries from './managers/Galleries';
import Accordions from './managers/Accordions';

// Animations
import MissionAnimation from './animations/MissionAnimation';
import OrbsAnimation from './animations/OrbsAnimation';

export class NKC {
	constructor() {
		Promise.all([NKC.domReady()]).then(() => this.init());
	}

	init() {
		// Components
		new Menu();
		new Cursor();

		// Managers
		new AjaxForms();
		new VimeoVideos();
		new Galleries();
		new Accordions();

		// Animations
		new MissionAnimation();
		new OrbsAnimation();

		const impactContainer = document.querySelector('[data-impact]');
		if (impactContainer) {
			new Modal(impactContainer);
		}

		// Bless document
		document.dispatchEvent(new Event('bless'));
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new NKC();
